// 既存回答のプリフィル用データ取得
const dataContainer = document.getElementById("data-container");
const savedWorkerQuestions = dataContainer ? JSON.parse(dataContainer.dataset.workerQuestions || "{}") : {};
const savedAllergies = dataContainer ? JSON.parse(dataContainer.dataset.allergy || "[]") : [];
const savedExclusionKeys = dataContainer ? JSON.parse(dataContainer.dataset.exclusionKeys || "[]") : [];
const savedDisplayName = dataContainer ? dataContainer.dataset.displayName || "" : "";

const startButton = document.getElementById("startBtn");
const nextButton = document.getElementById("nextBtn");
const backButton = document.getElementById("backBtn");
const backButtonConfirm = document.getElementById("backBtnConfirm");
const wtQuestionnaireTop = document.getElementById("questionnaireTop");
const wtQuestionnaireContainer = document.getElementById(
  "questionnaireContainer",
);
const wtQuestionnaireConfirm = document.getElementById("confirmContainer");
const questionTitle = document.getElementById("questionTitle");
const questionChoice = document.getElementById("questionChoice");
const answerButtons = document.getElementById("answerButtons");
let redoBtn = document.querySelectorAll(".wt-questionnaire__redo-btn");

// 既存回答をプリフィル
let scoreArray = {};
let allergyArray = savedAllergies.length > 0 ? savedAllergies : [];
let displayName = savedDisplayName;
let questionIndex = 0;
let redoFlg = false;
let isQ16Screen = false;

const formatQuestionTitle = (text) =>
  text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\n/g, "<br>")
    .replace(/（[^）]*）/g, '<span class="wt-questionnaire__question-sub">$&</span>');

// 既存回答をscoreArrayにプリフィル
function prefillScoreArray() {
  if (savedWorkerQuestions && typeof savedWorkerQuestions === 'object') {
    Object.keys(savedWorkerQuestions).forEach((key) => {
      const savedAnswer = savedWorkerQuestions[key];
      if (savedAnswer && savedAnswer.value) {
        scoreArray[key] = savedAnswer;
      }
    });
  }
  // ブラックコーヒーの回答をexclusionKeysから復元
  const wantsBlackCoffee = !savedExclusionKeys.includes('black_coffee');
  scoreArray['drink-black-coffee'] = {
    value: [{ key: wantsBlackCoffee ? 1 : 0 }]
  };
}
prefillScoreArray();

startButton.addEventListener("click", () => {
  window.scroll({
    top: 0,
  });
  wtQuestionnaireTop.classList.add("hide");
  wtQuestionnaireConfirm.classList.add("hide");
  wtQuestionnaireContainer.classList.remove("hide");
  showQuestion();
  nextButton.setAttribute("data-question-index", questionIndex);
});

nextButton.addEventListener("click", () => {
  window.scroll({
    top: 0,
  });

  pushAnswer();
  changePage();
  updatePageNumber();
  nextButton.setAttribute("data-question-index", questionIndex);

  if (
    questionIndex < questions.length - 1 &&
    !checkScoreArray()
  ) {
    nextButtonChange();
  }
});

backButton.addEventListener("click", () => {
  redoFlg = false;

  if (isQ16Screen) {
    isQ16Screen = false;
    resetState();
    showQuestion();
    nextButtonChange();
    return;
  }

  if (questionIndex === 0) {
    wtQuestionnaireTop.classList.remove("hide");
    wtQuestionnaireContainer.classList.add("hide");
    resetState();
    return;
  } else if (questionIndex > 0) {
    questionIndex--;
    resetState();
    showQuestion();

    if (questionIndex < questions.length - 1) {
      nextButtonChange();
    }
  }
});

backButtonConfirm.addEventListener("click", () => {
  wtQuestionnaireConfirm.classList.add("hide");
  wtQuestionnaireContainer.classList.remove("hide");

  // 再アンケートではお名前入力がないので、最後の設問（アレルギー）に戻る
  questionIndex = questions.length - 1;
  resetState();
  showQuestion();
});

redoBtn.forEach((button, index) => {
  button.addEventListener("click", () => {
    redoFlg = true;

    wtQuestionnaireConfirm.classList.add("hide");
    wtQuestionnaireContainer.classList.remove("hide");

    resetState();

    // 再アンケートではお名前入力がないので、indexをそのまま使用
    questionIndex = index;
    showQuestion();
  });
});

function showQuestion() {
  updatePageNumber();
  addClassMeter();
  mainContent();

  if (questions[questionIndex].type === "allergy") {
    const noAllergyAnswer = questions[questionIndex].answers.find(
      (answer) => answer.name === "該当なし",
    );
    if (!noAllergyAnswer) {
      nextButtonChange();
      return;
    }
    const noAllergyCheckbox = document.getElementById(
      "answer-" + noAllergyAnswer.key,
    );
    if (!noAllergyCheckbox) {
      nextButtonChange();
      return;
    }

    const allCheckboxes = Array.from(document.querySelectorAll('.answer-input'))
        .filter(checkbox => checkbox.id !== noAllergyCheckbox.id);

    if (noAllergyCheckbox.checked) {
      noAllergyCheckbox.disabled = true;
    }

    noAllergyCheckbox.addEventListener('change', () => {
      if (noAllergyCheckbox.checked) {
        allCheckboxes.forEach(chk => {
          chk.checked = false;
        });
        noAllergyCheckbox.disabled = true;
      } else {
        noAllergyCheckbox.disabled = false;
      }
    });

    allCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (checkbox.checked) {
          noAllergyCheckbox.checked = false;
          noAllergyCheckbox.disabled = false;
        }

        const noneSelected = allCheckboxes.every(chk => !chk.checked);
        if (noneSelected) {
          noAllergyCheckbox.checked = true;
          noAllergyCheckbox.disabled = true;
          nextButtonChange();
        }
      });
    });
  }

  // プリフィル済みの回答がある場合、次へボタンを有効化
  nextButtonChange();
}

function showQ16() {
  const pageNumberSpan = document.getElementById("pageNumber");
  if (pageNumberSpan) {
    pageNumberSpan.innerText = `${questions.length + 1} / ${questions.length + 1}`;
  }

  const segments = document.querySelectorAll('.wt-questionnaire__progress-segment');
  segments.forEach((segment) => segment.classList.add('active'));

  questionTitle.innerHTML = formatQuestionTitle("お名前を入力して下さい\n※通称名可");
  questionChoice.innerText = "";

  const inputContainer = document.createElement("div");
  inputContainer.classList.add("wt-questionnaire__text-input-container");

  const input = document.createElement("input");
  input.type = "text";
  input.id = "display-name-input";
  input.classList.add("wt-questionnaire__text-input");
  input.placeholder = "お名前を入力";
  input.value = displayName;
  input.setAttribute("oninput", "nextButtonChange()");

  inputContainer.appendChild(input);
  answerButtons.appendChild(inputContainer);

  nextButtonChange();
}

function changePage() {
  if (!redoFlg) {
    gtag('event', 'click', {
      event_category: 'cocoro_hitoiki_worker_type_re_questionnaire',
      event_label: 'next',
      value: questionIndex + 1,
    });
  }

  if (redoFlg) {
    if (isQ16Screen) {
      isQ16Screen = false;
    }
    resetState();
    showConfirm();

  } else if (isQ16Screen) {
    resetState();
    isQ16Screen = false;
    showConfirm();

  } else if (questionIndex === questions.length - 1 && questions[questionIndex].type === "allergy") {
    if (allergyArray.length === 0) {
      if (window.confirm("アレルギーの項目が選択されていませんが、アレルギー該当なしでよろしいですか？")) {
        allergyArray.push("none");
      } else {
        return
      }
    }
    resetState();
    // 再アンケートではお名前入力をスキップして確認画面へ
    showConfirm();

  } else {
    questionIndex++;
    resetState();
    showQuestion();
  }
}

function checkScoreArray() {
  return questions
    .filter((question) => question.type !== "allergy")
    .every((question) => scoreArray[question.key]);
}

function mainContent() {
  const currentQuestion = questions[questionIndex];
  const isAllergy = currentQuestion.type === "allergy";

  questionTitle.innerHTML = formatQuestionTitle(currentQuestion.question);
  questionChoice.innerText = currentQuestion.questionChoice;

  currentQuestion.answers.forEach((answer) => {
    const label = document.createElement("label");
    label.classList.add("wt-questionnaire__answer-button");

    const input = document.createElement("input");
    if (questionIndex <= questions.length - 1) {
      input.setAttribute("onchange", "nextButtonChange()");
    }
    input.classList.add("answer-input");
    const key = answer.key;

    if (key === 'none') {
      label.classList.add('answer-none');

      if (allergyArray.length === 1 && allergyArray.includes('none')) {
        input.checked = true;
      }
    }

    if (currentQuestion.multiple || isAllergy) {
      input.type = "checkbox";
    } else {
      input.type = "radio";

      input.addEventListener("change", () => {
        setTimeout(() => {
          window.scroll({ top: 0 });
          pushAnswer();
          changePage();
          updatePageNumber();
          nextButton.setAttribute("data-question-index", questionIndex);
          if (questionIndex < questions.length - 1 && !checkScoreArray()) {
            nextButtonChange();
          }
        }, 350);
      });
    }

    input.name = "answer";
    input.id = "answer-" + key;
    input.value = key;

    label.setAttribute("for", "answer-" + key);

    const labelText = document.createTextNode(answer.text);
    const labelTextEight = document.createTextNode(answer.name);
    if (isAllergy) {
      const questionsEight = document.createElement("div");
      const ingredients = document.createElement("p");
      questionsEight.classList.add("wt-questionnaire__answer-box");
      questionsEight.appendChild(input);
      questionsEight.appendChild(label);
      ingredients.appendChild(labelTextEight);
      questionsEight.appendChild(ingredients);

      answerButtons.appendChild(questionsEight);
    } else {
      label.appendChild(labelText);
      answerButtons.appendChild(input);
      answerButtons.appendChild(label);
    }

    const scoreKey = currentQuestion.key;
    if (
      (!isAllergy &&
        scoreArray[scoreKey] &&
        scoreArray[scoreKey]["value"].some((answer) => answer.key === key)) ||
      (isAllergy && allergyArray && allergyArray.includes(key))
    ) {
      input.checked = true;
    }
  });

  if (currentQuestion.type === "black-coffee") {
    const note = document.createElement("p");
    note.classList.add("wt-questionnaire__note");
    note.innerHTML = "※飲みたくないを選択した場合、セット内にブラックコーヒーが含まれなくなります。<br>サービス開始後にアンケート回答内容の変更は可能です。";
    answerButtons.appendChild(note);
  }
}

function addClassMeter() {
  const segments = document.querySelectorAll('.wt-questionnaire__progress-segment');
  const step = questionIndex + 1;
  segments.forEach((segment, index) => {
    if (index < step) {
      segment.classList.add('active');
    } else {
      segment.classList.remove('active');
    }
  });
}

function updatePageNumber() {
  const pageNumberSpan = document.getElementById("pageNumber");
  if (pageNumberSpan) {
    if (isQ16Screen) {
      pageNumberSpan.innerText = `${questions.length + 1} / ${questions.length + 1}`;
    } else {
      pageNumberSpan.innerText = `${questionIndex + 1} / ${questions.length + 1}`;
    }
  }
}

function pushAnswer() {
  if (isQ16Screen) {
    const textInput = document.getElementById("display-name-input");
    if (textInput) {
      displayName = textInput.value.trim();
    }
    return;
  }

  const currentQuestion = questions[questionIndex];
  let checkedValues = [];
  let checkedValuesConfirm = [];
  checkedValues = Array.from(document.querySelectorAll("input:checked")).map(
    (input) => parseInt(input.value),
  );
  checkedValuesConfirm = Array.from(
    document.querySelectorAll("input:checked"),
  ).map((input) => input.value);

  if (currentQuestion.type !== "allergy") {
    scoreArray[currentQuestion.key] = {
      title: currentQuestion.question,
      value: checkedValues.map((value) => ({
        key: value,
        text: currentQuestion.answers.find((answer) => answer.key === value)
          .text,
        score_active: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_active,
        score_impulse: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_impulse,
        score_stable: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_stable,
        score_careful: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_careful,
        score_behavior_style: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_behavior_style,
        score_work_style: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_work_style,
        score_thinking_type: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_thinking_type,
        score_energy_use: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_energy_use,
        score_pace_control: currentQuestion.answers.find((answer) => answer.key === value)
          ?.score_pace_control,
      })),
    };
  } else {
    allergyArray = checkedValuesConfirm;
  }
}

function nextButtonChange() {
  const textInput = document.getElementById("display-name-input");
  if (textInput) {
    nextButton.disabled = textInput.value.trim() === "";
    return;
  }

  let allCheckboxes = document.querySelectorAll(".answer-input");
  let atLeastOneChecked = Array.from(allCheckboxes).some(
    (checkbox) => checkbox.checked,
  );
  nextButton.disabled = !atLeastOneChecked;
}

function resetState() {
  while (answerButtons.firstChild) {
    answerButtons.removeChild(answerButtons.firstChild);
  }
}

function showConfirm() {
  wtQuestionnaireContainer.classList.add("hide");
  wtQuestionnaireConfirm.classList.remove("hide");

  const confirmInput = document.querySelectorAll(".confirm-input .answer");
  function extractTextByKey(key, data, isAllergy) {
    let results = [];

    data.forEach((item) => {
      key.forEach((el) => {
        if (item.key === el) {
          results.push(isAllergy ? item.name : item.text);
        }
      });
    });

    return results;
  }

  confirmInput.forEach((el, index) => {
    const currentQuestion = questions[index];
    let answersVariableKey = [];

    if (currentQuestion.type === "allergy") {
      answersVariableKey = allergyArray;
      el.innerText = extractTextByKey(
        answersVariableKey,
        currentQuestion.answers,
        true,
      );
    } else {
      answersVariableKey = scoreArray[currentQuestion.key]["value"].map(
        (answer) => answer.key,
      );
      el.innerText = extractTextByKey(
        answersVariableKey,
        currentQuestion.answers,
        false,
      );
    }
  });
}

const loder = () => {
  const form = document.forms[0];
  const button = form.querySelector(".confirm-button");
  const loader = form.querySelector(".wt-questionnaire__loader");

  button.addEventListener(
    "click",
    (e) => {
      e.preventDefault();

      loader.style.display = "block";

      allergyModal();
    },
    false,
  );
};
loder();

const allergyModal = () => {
  const milk = allergyArray.includes("milk");
  const caffeine = allergyArray.includes("caffeine");
  const milkModal = document.querySelector(".wt-questionnaire__modal-milk");
  const caffeineModal = document.querySelector(
    ".wt-questionnaire__modal-coffee",
  );
  const form = document.forms[0];
  const loader = form.querySelector(".wt-questionnaire__loader");

  if (milk && caffeine) {
    milkModal.classList.remove("hide");
    loader.style.display = "none";
    document.body.style.overflow = "hidden";
  } else if (milk) {
    milkModal.classList.remove("hide");
    loader.style.display = "none";
    document.body.style.overflow = "hidden";
  } else if (caffeine) {
    caffeineModal.classList.remove("hide");
    loader.style.display = "none";
    document.body.style.overflow = "hidden";

    const coffeeConfirmButton = document.querySelector(
      ".coffee-confirm-button",
    );
    coffeeConfirmButton.addEventListener("click", () => {
      sendResult();
    });
  } else {
    milkModal.classList.add("hide");
    caffeineModal.classList.add("hide");

    sendResult();
  }
};

function sendResult() {
  const loader = document.querySelector(".wt-questionnaire__loader");
  const wantsBlackCoffee = !!(
    scoreArray["drink-black-coffee"] &&
    scoreArray["drink-black-coffee"].value.some((answer) => answer.key === 1)
  );
  const exclusionKeys = wantsBlackCoffee ? [] : ["black_coffee"];
  const answersPayload = { ...scoreArray };
  delete answersPayload["drink-black-coffee"];

  fetch("/apps/cocoro-hitoiki-api/v1/worker_type_answers", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      answers: answersPayload,
      allergies: allergyArray,
      exclusionKeys,
      displayName,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      if (data) {
        // 結果ページで使用するためにlocalStorageに保存
        localStorage.setItem('reQuestionnaireResult', JSON.stringify({
          workerType: data.workerType,
          scoreArray: scoreArray
        }));
        window.location.href =
          "/pages/cocoro-hitoiki-re-questionnaire-lp2-result";
      } else {
        throw new Error("Network response was not ok");
      }
    })
    .catch(() => {
      loader.style.display = "none";
      showConfirm();
    });
}
